module.exports = __webpack_public_path__ + "img/Digital-outreach-600x400.4defb151.png";